import { Component, OnInit, ChangeDetectorRef, AfterContentChecked } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { DiagnoseTemplateList } from 'projects/Administration/src/app/business-entities/diagnose-template-modal';
import { DiagnoseTemplateBusinessService } from 'projects/Administration/src/app/business-services/diagnose-template.service';
import { BaseService } from 'projects/Autofacets-Core/src/app/services/base.service';
import * as Enums from './../../../../../../../../Autofacets-Core/src/app/utils/enums';
import { CurrentLanguage } from '../../../../../../../../Autofacets-Core/src/app/common-services/current-language.service';
import { DiagnoseTemplate } from '../../../../../business-entities/diagnose-template-modal';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserDataService } from 'src/app/DataServices/user-data.service';
@Component({
  selector: 'app-edit-diagnose-template',
  templateUrl: './edit-diagnose-template.component.html'
})
export class EditDiagnoseTemplateComponent implements OnInit, AfterContentChecked  {
  editDiagnoseTemplate = false;
  editDiagnoseTemplateForm: FormGroup;
  DiagnoseTemplate:DiagnoseTemplate={
    diagnoseTemplates:[],
    templateLanguageDetails:[]
  }
  id: number;
  templateType = [{id:1,name:"Diagnose"},{id:2,name:"Cause"},
              {id:3,name:"Solution and Result"},{id:4,name:"Cause Code"}];
  diagnoseTemplateList: DiagnoseTemplateList[];
  languageList: any[];
  constructor(
    private activeModal : NgbActiveModal,
    private formBuilder: FormBuilder,
    private diagnoseTemplateService: DiagnoseTemplateBusinessService,
    private spinner: NgxSpinnerService,
    private baseService: BaseService,
    private toastr: ToastrService,
    private router: Router,
    private translate: TranslateService,
    private currentLanguageService: CurrentLanguage,
    private cdref: ChangeDetectorRef,
    private userService: UserDataService
  ) { }

  ngOnInit(): void {

    this.languageList = this.currentLanguageService.LanguageList;
    this.editDiagnoseTemplateForm = this.formBuilder.group({
      templateId: [null, [Validators.required]],
      service: new FormArray([]),
      isActive:[false]
    });
    this.getLanguage()
    this.id = this.diagnoseTemplateService.diagnoseTemplateId
    this.getDiagnoseTemplateById(this.id);

  }
  OnClose(){
    this.activeModal.close({success:false})
  }
  get cpf() {
    return this.editDiagnoseTemplateForm.controls;
  }
  get t() { return this.cpf.service as FormArray; }
  getLanguage() {
    const number = this.currentLanguageService.LanguageList.length;
    if (this.t.length < number) {
        for (let i = this.t.length; i < number; i++) {
            this.t.push(this.formBuilder.group({
                languageId: ['',Validators.required],
                name: ['', Validators.required],
                description: ['', Validators.required],
            }));
        }
    } else {
        for (let i = this.t.length; i >= number; i--) {
            this.t.removeAt(i);
        }
    }
}

ngAfterContentChecked(): void {
  this.cdref.detectChanges();
}
  async getDiagnoseTemplateById(id:number)
  {
    this.spinner.show();
    await this.diagnoseTemplateService.getDiagnoseTemplateById(id).then(result => {
      if (result) {
        this.DiagnoseTemplate = result;
        this.editDiagnoseTemplateForm.patchValue({
          service:this.DiagnoseTemplate.templateLanguageDetails,
          isActive:this.DiagnoseTemplate.diagnoseTemplates[0].isActive,
          templateId:this.DiagnoseTemplate.diagnoseTemplates[0].listType
       });
      }
    })
    this.spinner.hide();
  }
  editDiagnoseTemplates()
  {
  let viewModel={
    isActive:  this.editDiagnoseTemplateForm.value.isActive,
    templateId: this.editDiagnoseTemplateForm.value.templateId,
    lnlnvalue: this.editDiagnoseTemplateForm.value.service,
    currentUser: this.userService.currentUserValue.userId,
    id: this.id
  }
  this.diagnoseTemplateService.addDiagnoseTemplate(viewModel).then(res => {
    if (res.responseCode === Enums.ErrorCodes.SuccessCode) {
      let succesMsg = this.translate.instant("lblDiagnoseTemplateUpdated");
      this.toastr.success(succesMsg);
      this.activeModal.close({ success: true
      });
      this.spinner.hide();
    }
    else if (res.responseObject === false) {
      let internalErrorMessage = this.translate.instant("lblDiagnoseTemplateExist");
      this.spinner.hide();
      this.toastr.error(internalErrorMessage);
    }
  });
  }
}
